import { useCallback, useEffect, useState } from 'react'
import { DefaultTheme } from 'styled-components'
import { defaultTheme } from '@/shared/theme'

export const useAppThemeProviderController = () => {
  const [theme, setTheme] = useState(defaultTheme)

  const [isCuraAPIReady, setIsCuraAPIReady] = useState(false)

  const handleCuraReady = useCallback(() => {
    if (isCuraAPIReady || !window.CuraAPI) {
      return
    }

    const updatedTheme: DefaultTheme = {
      ...theme,
      breakpoints: {
        ...theme.breakpoints,
        get: window.CuraAPI.theme.breakpoints.get
      },
      colors: {
        ...theme.colors,
        getColor: window.CuraAPI.theme.colors.getColor
      },
      fonts: {
        ...theme.fonts,
        getWeights: window.CuraAPI.theme.fonts.getWeights
      }
    }

    setTheme(updatedTheme)

    setIsCuraAPIReady(true)
  }, [theme, setIsCuraAPIReady, isCuraAPIReady])

  const listenForCuraAPIReady = useCallback(() => {
    if (window.CuraAPI || isCuraAPIReady) {
      return
    }

    window.addEventListener('CuraAPIReady', handleCuraReady)
  }, [handleCuraReady, isCuraAPIReady])

  const stopListenForCuraAPIReady = useCallback(() => {
    window.removeEventListener('CuraAPIReady', handleCuraReady)
  }, [handleCuraReady])

  useEffect(() => {
    handleCuraReady()
    listenForCuraAPIReady()

    return stopListenForCuraAPIReady
  }, [handleCuraReady, listenForCuraAPIReady, stopListenForCuraAPIReady])

  return {
    theme,
    isCuraAPIReady
  }
}
